export default "__VITE_ASSET__C3d8pdbr__"